import React from "react";
import { Paper } from "@material-ui/core";
import { resultsFields } from "../../constants";
import { fmt3 } from "../../utils";
const _ = require('lodash');

function Result(props) {
  const { selectedVessels = {}, calculationErrors = [], getCurrentResult = {}, calculatorData = {} } = props;
  const isEqual = _.isEqual(calculatorData, getCurrentResult)
  return (
    <div className="flex flex-col h-full bg-white" id="result-details">
      {/* HEADER stays at the top */}
      <div className="calculator-section-header result-section result-details-header">
        <h4 className="result-heading font-medium text-[12px] m-0" style={{ color: "#ffffff" }}>Result Details</h4>
      </div>

      {/* BODY grows to fill available space */}
      <div className="flex-1 overflow-auto">
        <table className="fleet-result-table result-details-table w-full">
          <tbody>
            {resultsFields.map((item, key) => {
              const rawVal = selectedVessels[item.value];
              const hasVal =
                rawVal !== undefined && rawVal !== null && !isNaN(Number(rawVal));
              const numVal = hasVal ? Number(rawVal) : 0;
              const isMinus = numVal < 0;
              const isProfitField = item.label?.toLowerCase().includes("profit");

              return (
                <tr key={key}>
                  <th style={{ width: "48%" }}>{item.label}</th>
                  <td className="text-[11px] px-[6px] text-right">
                    {isProfitField ? (
                      <div className="flex items-center justify-end gap-1.5 h-full">
                        <span
                          className={`result-indicator-dot ${
                            isMinus ? "is-negative" : "is-positive"
                          }`}
                        />
                        <span
                          className={`result-indicator-value tabular-nums ${
                            isMinus ? "is-negative" : "is-positive"
                          }`}
                        >
                          {fmt3(numVal)}
                        </span>
                      </div>
                    ) : (
                      <span className="tabular-nums">{fmt3(numVal)}</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ERRORS stay at the bottom */}
      <div className="flex-shrink-0 mt-auto p-1">
        {calculationErrors.length ? (
          <div className="bg-rose-50 border border-rose-200 text-rose-700 p-1.5 rounded-none">
            <p className="text-[11px] font-semibold mb-1 m-0">List of Errors</p>
            <div className="max-h-[140px] overflow-auto space-y-0.5">
              {calculationErrors.map((item, index) => (
                <p key={index} className="text-[10.5px] leading-tight m-0">
                  {index + 1}. {item.message}
                </p>
              ))}
            </div>
          </div>
        ) : (
          <div className="bg-emerald-50 border border-emerald-200 text-emerald-700 py-1 px-2 text-[11px] font-medium text-center">
            No Error Found.
          </div>
        )}
      </div>
    </div>
  );
}

export default Result;
